import { assert } from "@/helpers/helpers";
import { GET } from "@/state/api";
import { server } from "@/state/server";
import { createFileRoute } from "@tanstack/react-router";
import { useRef } from "react";
import { z } from "zod";

const SearchZod = z.object({ id: z.number() });

export const Route = createFileRoute("/admin/pedido/anular")({
  component: RouteComponent,
  validateSearch: SearchZod,
  loader: async (params) =>
    await GET("/admin/pedido/:id/anular", {
      p: {
        id: (params.location.search as z.infer<typeof SearchZod>).id,
      },
    }),
});

function RouteComponent() {
  const pedido = Route.useLoaderData();
  const razon = useRef<HTMLInputElement>(null);

  assert(pedido);

  return (
    <div>
      <h1>Anular pedido</h1>
      <div>Fecha: {pedido.fecha}</div>
      <ul>
        {pedido.operaciones.map((op) => (
          <li>
            {op.cuenta}: {op.valor} {op.moneda}
          </li>
        ))}
      </ul>
      <div>
        Razón: <input ref={razon} />
      </div>
      <button
        onClick={() => {
          const r = razon.current?.value;
          if (!r) {
            alert("Falta la razón");
            return;
          }
          fetch(`${server}/admin/pedido/${pedido.id}/anular_forzado`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ razon: r }),
          });
          window.history.back(); // TODO: invalidate
        }}
      >
        Forzar anulación
      </button>
    </div>
  );
}
